import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { LoggingService } from '../../services/logging.service';

interface HealthItem {
  icon: string;
  title: string;
  description: string;
  route: string;
}

@Component({
  selector: 'app-my-health',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './my-health.component.html',
  styleUrls: ['./my-health.component.css']
})
export class MyHealthComponent implements OnInit {
  healthItems: HealthItem[] = [
    {
      icon: 'assets/icon-period-tracker.png',
      title: 'Period Tracker',
      description: 'Track your menstrual cycle',
      route: '/period-tracker'
    },
    {
      icon: 'assets/icon-noti-medication.png',
      title: 'Medicine Reminder',
      description: 'Get reminders for your medications',
      route: '/medicine-reminder'
    },
    {
      icon: 'assets/icon-noti-appointment.png',
      title: 'Appointment Reminder',
      description: 'Get reminders for your appointments',
      route: '/appointment-reminder'
    }
  ];

  constructor(private router: Router, private loggingService: LoggingService) { }

  ngOnInit(): void { }

  navigateTo(route: string, title: string): void {
    this.loggingService.logEvent('select_content', {
      content_type: 'health_item',
      item_id: title,
    });
    this.router.navigate([route]);
  }
}
